import { render, staticRenderFns } from "./UserProfileNewUserVoucherCard.vue?vue&type=template&id=3be0b89a"
import script from "./UserProfileNewUserVoucherCard.vue?vue&type=script&lang=js"
export * from "./UserProfileNewUserVoucherCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports